import { render, staticRenderFns } from "./create-update-delete-pop-up.vue?vue&type=template&id=5f5024ff&"
import script from "./create-update-delete-pop-up.vue?vue&type=script&lang=ts&"
export * from "./create-update-delete-pop-up.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports